import { useMemo, useState } from 'react';

interface JsonViewerProps {
  value: unknown;
  className?: string;
  collapsedLines?: number;
}

export function JsonViewer({ value, className = '', collapsedLines = 18 }: JsonViewerProps) {
  const [isExpanded, setIsExpanded] = useState(false);

  const text = useMemo(() => JSON.stringify(value, null, 2), [value]);

  const maxHeight = isExpanded ? 'max-h-[70vh]' : `max-h-[${collapsedLines}lh]`;

  async function copy() {
    try {
      await navigator.clipboard.writeText(text);
    } catch {
      // ignore clipboard failures (e.g. non-secure context)
    }
  }

  return (
    <div className={className}>
      <div className="flex items-center justify-between mb-2">
        <div className="flex gap-2">
          <button
            type="button"
            onClick={() => setIsExpanded((v) => !v)}
            className="px-2 py-1 text-xs font-medium rounded bg-gray-100 hover:bg-gray-200 text-gray-800"
          >
            {isExpanded ? 'Collapse' : 'Expand'}
          </button>
          <button
            type="button"
            onClick={() => copy()}
            className="px-2 py-1 text-xs font-medium rounded bg-gray-100 hover:bg-gray-200 text-gray-800"
          >
            Copy
          </button>
        </div>
        <span className="text-xs text-gray-500">{text.length.toLocaleString()} chars</span>
      </div>

      <pre
        className={`text-xs bg-gray-50 border border-gray-200 rounded-lg p-3 overflow-auto ${maxHeight}`}
      >
        {text}
      </pre>
    </div>
  );
}

